import { parse, distanceInWordsToNow, format } from 'date-fns'

export default {
  methods: {
    defaultFormatAndParse(dateString) {
      return format(parse(dateString), 'MM/DD/YYYY')
    },

    format(dateObjectToFormat, formatString) {
      return format(dateObjectToFormat, formatString)
    },

    distanceInWordsToNow(dateObject) {
      return distanceInWordsToNow(dateObject)
    },

    parse(dateString) {
      return parse(dateString)
    }
  }
}
